/* ═══ MIRIAM LLANTADA · FICHA DE PRODUCTO 05 + GALERÍA H2 ═══
   Sin dependencias, compatible con defer. Se inicia por instancia,
   para el editor de temas. Expone window.MLProducto.init(root). */
(function () {
  "use strict";

  /* En cada uso: puede cambiar en caliente. */
  function suave() {
    var mm = window.matchMedia;
    return mm && mm("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  }
  function lista(n) { return Array.prototype.slice.call(n || []); }
  /* La suavidad la manda el JS y solo el JS: pedirla también desde el
     CSS dejaba el mando en ninguno, y hay Chrome donde el suave
     programático no mueve un píxel. Se pide, se comprueba y se coloca.
     PLAN 9.32: no devolver scroll-behavior a la hoja. */
  function desliza(el, o) {
    if (!el) return;
    var eje = o.left != null ? "scrollLeft" : "scrollTop";
    var meta = o.left != null ? o.left : o.top;
    var poner = function () { if (Math.abs(el[eje] - meta) > 2) el[eje] = meta; };
    var modo = suave();
    window.clearTimeout(el.mlVerifica);
    if (typeof el.scrollTo === "function") el.scrollTo({ left: o.left, top: o.top, behavior: modo });
    if (modo === "smooth") el.mlVerifica = window.setTimeout(poner, 420);
    else poner();
  }
  function correa() {
    var atados = [];
    var atar = function (el, ev, fn, op) {
      el.addEventListener(ev, fn, op);
      atados.push(function () { el.removeEventListener(ev, fn); });
    };
    atar.soltar = function () { while (atados.length) atados.pop()(); };
    return atar;
  }

  /* ── GALERÍA · el recuento real manda sobre data-n ──── */
  function iniciarGaleria(gal) {
    if (gal.mlIniciado) return;
    gal.mlIniciado = true;
    var track = gal.querySelector("[data-ml-track]");
    var slides = track ? lista(track.querySelectorAll("[data-ml-slide]")) : [];
    var total = slides.length;
    gal.setAttribute("data-n", String(total));
    gal.classList.remove("is-una", "is-pocas", "is-vacia");
    if (total === 0) gal.classList.add("is-vacia");
    else if (total === 1) gal.classList.add("is-una");
    else if (total < 4) gal.classList.add("is-pocas");

    if (total < 2) {
      if (track) { track.removeAttribute("tabindex"); track.removeAttribute("aria-roledescription"); }
      return;
    }

    var rail = gal.querySelector("[data-ml-rail]");
    var thumbs = lista(gal.querySelectorAll("[data-ml-thumb]"));
    /* EL PIE ES data-ml-galcap, Y HASTA EL 02/09/2026 ERA data-ml-cap.
       Se renombró porque ese nombre estaba puesto dos veces en el tema con
       dos significados distintos: aquí era «caption», el pie de foto de la
       galería, y en snippets/ml-cap-marco.liquid es «capítulo» de la ficha de
       producto físico, con el slug dentro (data-ml-cap="garantia"). En una
       ficha física conviven en la misma página: medido el 02/09/2026 sobre la
       página del banco, que monta ocho capítulos, nueve nodos respondían a
       data-ml-cap y el noveno era este pie.

       No rompía nada porque los dos lectores buscan acotados —este dentro de
       gal, y assets/ml-capitulos.js dentro de [data-ml-caps] y emparejando
       por slug—, pero era una trampa esperando: ml-capitulos.js ya tiene un
       document.querySelector de reserva para [data-ml-caps], así que
       simplificar su caps.querySelectorAll a document.querySelectorAll habría
       metido este pie en la lista de capítulos. Y por delante, no por detrás:
       la galería vive en el hero, así que en orden de documento el pie sale
       ANTES que todos los capítulos y los corre un puesto a todos —la lista
       pasaba a ["", "objeto", "ritual", …], con la cadena vacía en la
       posición 0—. Sin excepción y sin rastro en el HTML.

       Se renombró este y no el de capítulos porque el de capítulos es un slug
       del que dependen el emparejamiento con la barra y el ancla id="cap-…".
       Este solo lo lee su propia galería. Si vuelves a tocarlo, los dos lados
       tienen que cuadrar: la prueba Q19 cruza los data-ml-* del JS contra los
       del Liquid en los dos sentidos. */
    var cap = gal.querySelector("[data-ml-galcap]");
    var live = gal.querySelector("[data-ml-live]");
    var ultima = total - 1, actual = -1, espera = null, alAbrir = true;
    var atar = correa();
    function paso() {
      var d = slides[1].offsetLeft - slides[0].offsetLeft;
      return d > 0 ? d : slides[0].offsetWidth || 1;
    }
    /* Al abrir, arriba del todo; centrar es para navegar. Y se mide con
       rect: el rail no está posicionado y offsetTop iba al tope. PLAN 9.41. */
    function verEnRail(i, arriba) {
      var b = thumbs[i];
      if (!rail || !b) return;
      var vert = rail.scrollHeight > rail.clientHeight + 2;
      if (!vert && rail.scrollWidth <= rail.clientWidth + 2) return;
      if (arriba) { desliza(rail, vert ? { top: 0 } : { left: 0 }); return; }
      var cb = b.getBoundingClientRect(), cr = rail.getBoundingClientRect();
      if (vert) desliza(rail, { top: Math.max(0, rail.scrollTop + cb.top - cr.top - (rail.clientHeight - cb.height) / 2) });
      else desliza(rail, { left: Math.max(0, rail.scrollLeft + cb.left - cr.left - (rail.clientWidth - cb.width) / 2) });
    }
    /* Único sitio donde se escribe el estado visible. La región viva
       calla en la primera pasada: si no, el lector la anuncia sola. */
    function pintar(i) {
      if (i === actual) return;
      var arranque = actual === -1;
      actual = i;
      if (cap) cap.textContent = slides[i].getAttribute("data-caption") || "";
      /* El anuncio de la región viva viene puesto en la propia diapositiva,
         en data-anuncio, con los dos números ya dentro. Aquí estaba escrito
         "Imagen " + (i + 1) + " de " + total, o sea una frase en castellano
         montada a trozos dentro del JS: un .js no pasa por el filtro t de
         Shopify y tampoco lo ve Translate & Adapt, así que con el inglés
         publicado esa frase se la quedaba en castellano quien navegara en
         inglés, y no había manera de arreglarlo sin tocar el código. Ahora
         la escribe Liquid, en el idioma del escaparate, y aquí solo se
         copia. Ver snippets/ml-galeria-columna.liquid. */
      if (live && !arranque) live.textContent = slides[i].getAttribute("data-anuncio") || "";
      for (var n = 0; n < thumbs.length; n++) {
        thumbs[n].classList.toggle("is-on", n === i);
        if (n === i) thumbs[n].setAttribute("aria-current", "true");
        else thumbs[n].removeAttribute("aria-current");
      }
      verEnRail(i, alAbrir);
      alAbrir = false;
    }
    function sincronizar() {
      var i = Math.round(track.scrollLeft / paso());
      pintar(i < 0 ? 0 : i > ultima ? ultima : i);
    }
    function irA(i) {
      if (i < 0) i = 0;
      if (i > ultima) i = ultima;
      pintar(i);
      desliza(track, { left: i * paso() });
    }
    function alScroll() { window.clearTimeout(espera); espera = window.setTimeout(sincronizar, 90); }
    /* Home y End los pide WAI-ARIA. preventDefault solo si va a haber
       movimiento: si no, la tecla se pierde. */
    function alTeclear(e) {
      var destino;
      if (e.key === "ArrowRight") destino = actual + 1;
      else if (e.key === "ArrowLeft") destino = actual - 1;
      else if (e.key === "Home") destino = 0;
      else if (e.key === "End") destino = ultima;
      else return;
      if (destino < 0 || destino > ultima || destino === actual) return;
      e.preventDefault();
      irA(destino);
    }
    function alRedimensionar() {
      window.clearTimeout(espera);
      espera = window.setTimeout(function () { actual = -1; sincronizar(); }, 120);
    }
    atar(track, "scroll", alScroll, { passive: true });
    atar(track, "keydown", alTeclear);
    thumbs.forEach(function (b, n) { atar(b, "click", function () { irA(n); }); });
    atar(window, "resize", alRedimensionar);
    pintar(0);
    gal.mlDestruir = function () {
      window.clearTimeout(espera);
      window.clearTimeout(track.mlVerifica);
      if (rail) window.clearTimeout(rail.mlVerifica);
      atar.soltar();
    };
  }

  /* ── PRECIOS · Liquid manda el precio formateado ──── */
  function precio(v) {
    if (v == null) return "";
    if (typeof v === "string") return v;
    var n = Number(v) / 100;
    return isFinite(n) ? n.toFixed(2).replace(".", ",") + " €" : "";
  }

  /* Siempre textContent: con datos del comerciante no se inyecta
     marcado. La rebaja la decide el null de Liquid. */
  function escribirPrecio(nodo, v) {
    if (!nodo) return;
    var ahora = nodo.querySelector("[data-ml-price-now]");
    var antes = nodo.querySelector("[data-ml-price-was]");
    if (ahora) ahora.textContent = precio(v.price);
    else nodo.textContent = precio(v.price);
    if (antes) {
      var rebaja = v.compare_at_price != null && v.compare_at_price !== "";
      antes.textContent = rebaja ? precio(v.compare_at_price) : "";
      antes.hidden = !rebaja;
    }
  }

  /* ── PANEL DE COMPRA · el JSON de Liquid es el origen ──── */
  function iniciarCompra(buy) {
    if (buy.mlIniciado) return;
    buy.mlIniciado = true;
    var fuente = buy.querySelector("[data-ml-variants]");
    var opts = buy.querySelector("[data-ml-opts]");
    var form = buy.querySelector("[data-ml-form]");
    var atar = correa();
    buy.mlDestruir = atar.soltar;
    /* La regla del cajón en móvil es de la ficha, no de la barra flotante:
       ver el bloque largo de sincronizarCajon, más abajo. Va lo primero y
       antes de cualquier «return» de esta función, para que valga también en
       una ficha con el JSON de variantes ilegible. */
    sincronizarCajon();
    var campoId = form ? (form.querySelector("[data-ml-variant-id]") || form.querySelector('[name="id"]')) : null;
    var boton = form ? (form.querySelector("[data-ml-add]") || form.querySelector('[type="submit"]')) : null;
    function marcada() {
      var r = opts ? opts.querySelectorAll('input[data-ml-variante],input[type="radio"]') : [];
      for (var i = 0; i < r.length; i++) { if (r[i].checked) return r[i]; }
      return null;
    }
    /* Va lo primero: el identificador enviado sale del radio marcado
       aunque el JSON sea ilegible (PLAN 9.26). */
    function fijarId() {
      var m = marcada();
      if (m && campoId) campoId.value = String(m.value);
    }
    if (opts && campoId) {
      atar(opts, "change", fijarId);
      if (form) atar(form, "submit", fijarId);
      /* Y también en el clic del botón, que ocurre ANTES del envío.
         Desde que el formulario vive dentro de <product-form-component>,
         quien manda el añadir al carrito es el JS de Horizon: se ata en
         document y en FASE DE CAPTURA, así que lee el FormData —y con él el
         name="id"— antes que cualquier listener de «submit» colgado de este
         formulario, incluido el de la línea de arriba. El de «submit» se
         queda porque sin JavaScript de Horizon —un error de red al cargar el
         módulo, por ejemplo— vuelve a ser el que llega a tiempo; el del clic
         es el que llega a tiempo cuando Horizon sí está. Los dos hacen lo
         mismo y ponerlo dos veces no cuesta nada. */
      if (boton) atar(boton, "click", fijarId);
    }

    if (!fuente || !opts) return;
    var variantes;
    try { variantes = JSON.parse(fuente.textContent || "[]"); } catch (e) { return; }
    if (!variantes || !variantes.length) return;
    var nodoPrecio = buy.querySelector("[data-ml-price]");
    var barraPrecio = document.querySelector("[data-ml-buybar-price]");
    var textoBoton = boton ? boton.querySelector("[data-ml-cta-text]") || boton : null;
    var etiqueta = (boton && boton.getAttribute("data-ml-cta-label")) ||
      (textoBoton ? textoBoton.textContent.trim() : "");
    /* Y su pareja: la leyenda de agotado. Aquí estaba escrita "Agotado" a
       pelo, en castellano y dentro del código, que con el inglés publicado
       es un texto que ningún traductor puede alcanzar. Viaja del Liquid al
       JS por el mismo camino que la de venta —un atributo data-*, que es lo
       que hace Horizon cuando una cadena tiene que llegar al JS— y se lee
       aquí una sola vez, no en cada repintado.

       La reserva es la cadena vacía y no un literal en castellano: si el
       atributo faltara, un botón sin texto se ve a la primera y se arregla;
       un botón que dice "Agotado" en una tienda inglesa no lo ve nadie. */
    var etiquetaAgotado = (boton && boton.getAttribute("data-ml-cta-agotado")) || "";
    function buscar(id) {
      for (var i = 0; i < variantes.length; i++) { if (String(variantes[i].id) === String(id)) return variantes[i]; }
      return null;
    }
    /* Desde el 21/08/2026 el boton de la barra flotante tambien compra, asi
       que tiene que decir y hacer lo mismo que este: un boton que sigue
       ofreciendo comprar una variante agotada es una promesa falsa, y antes
       daba igual porque solo subia la pagina. Se pinta aqui y no en
       iniciarBuybar porque aqui es donde se sabe que variante esta marcada;
       alli solo se sabe donde esta la barra. */
    var barraCta = document.querySelector("[data-ml-buybar-cta]");
    function pintarBoton(v) {
      if (!boton) return;
      var hay = v.available !== false;
      boton.disabled = !hay;
      boton.classList.toggle("is-off", !hay);
      if (textoBoton) textoBoton.textContent = hay ? etiqueta : etiquetaAgotado;
      if (barraCta) {
        barraCta.disabled = !hay;
        barraCta.classList.toggle("is-off", !hay);
        barraCta.textContent = hay ? etiqueta : etiquetaAgotado;
      }
    }
    function aplicar(v) {
      if (!v) return;
      escribirPrecio(nodoPrecio, v);
      if (barraPrecio) barraPrecio.textContent = precio(v.price);
      if (campoId) campoId.value = String(v.id);
      pintarBoton(v);
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", String(v.id));
          window.history.replaceState({}, "", url.toString());
        } catch (e) { /* sin URL: el precio ya se ha actualizado */ }
      }
    }
    atar(opts, "change", function () {
      var m = marcada();
      if (m) aplicar(buscar(m.value));
    });

    var inicial = marcada();
    var v0 = inicial ? buscar(inicial.value) : null;
    if (v0) {
      escribirPrecio(nodoPrecio, v0);
      if (barraPrecio) barraPrecio.textContent = precio(v0.price);
      pintarBoton(v0);
    }
  }

  /* ── BARRA FLOTANTE ────
     El observador avisa; la geometría decide, también al arrancar y sin
     esperar registro. Sin listener de scroll (PLAN 9.33). */

  /* ¿ES MÓVIL? SE PREGUNTA POR EL ANCHO **Y POR EL ALTO**, y lo segundo es del
     03/09/2026: la hoja pregunta si la disposición es estrecha y el guion
     pregunta SI EL CAJÓN CABE, que se mide a lo alto. La explicación entera,
     con las cuatro ventanas medidas y de dónde sale el 500, vive en
     assets/ml-capitulos.js, que no tiene techo de peso; este archivo va contra
     los 32 KB del criterio 14 y la prosa se mudó allí el 10/09/2026 sin
     cambiar una palabra. La cadena tiene que decir lo mismo en los dos. N35. */
  var MOVIL = "(max-width: 768px), (max-height: 500px)";
  function esMovil() {
    return !!(window.matchMedia && window.matchMedia(MOVIL).matches);
  }

  /* EN MÓVIL EL CAJÓN NO SE ABRE SOLO, Y ESTE ES EL PORQUÉ.
     Medido el 21/08/2026 en 375×812 con UNA sola línea en la cesta: el
     resumen —de «Resumen» a PayPal— ocupa 611 px, o sea el 75% de la
     pantalla, y a la línea le quedan 127 px de los 291 que necesita. El
     cliente ve el título del producto cortado por la mitad de una frase, y el
     precio, el selector de cantidad y el botón de quitar caen fuera. Abrir
     eso encima de la ficha es enseñar algo peor que no enseñar nada.

     No se apaga con un ajuste nuestro sino quitando el atributo «auto-open»
     de <cart-drawer-component>, que es el interruptor que Horizon ya lee en
     assets/cart-drawer.js. Así no hay dos mecanismos que puedan discrepar, y
     si alguien apaga auto_open_cart_drawer en el editor de temas el atributo
     no está, no lo ponemos nosotros, y sigue mandando el editor.

     Se sincroniza en el arranque y cada vez que cambia el ancho, no en cada
     clic: así no hay carrera con el evento del carrito y la regla vale para
     TODOS los botones de comprar de la ficha —el del panel, el de esta barra
     y el de la barra de capítulos—, que es lo que evita que el mismo gesto
     haga dos cosas distintas en la misma pantalla.

     Y SE LLAMA DESDE iniciarCompra(), NO DESDE iniciarBuybar(), desde el
     02/09/2026. Estuvo colgado de la barra flotante desde el principio y era
     un error que no daba la cara: la barra solo se pinta si el hero trae
     «mostrar_barra» marcado, y templates/product.ml-fisicos.json lo trae en
     false. O sea que en la ficha de producto físico —la de los siete
     capítulos— esta función NO SE LLAMABA NUNCA y el cajón seguía abriéndose
     solo en un móvil de 375 px, que es exactamente la pantalla que este
     bloque describe como «peor que no enseñar nada». Se medía cero, porque
     ninguna prueba abría esa ficha en un navegador hasta el 02/09/2026.

     El panel [data-ml-buy] es el sitio correcto: es lo único que hay en TODA
     ficha de producto, con barra o sin ella, y la regla es de la ficha entera
     y no de ninguna de sus dos barras.

     ALCANCE: esto vive en el JS de la ficha, así que gobierna la ficha. La
     página de tienda tiene su propio añadir rápido y ahí el cajón se sigue
     abriendo en móvil. Arreglarlo de verdad es arreglar el cajón —resumen
     plegable o pie fijo con total y botón— y es un encargo aparte. */
  var cajonSincronizado = false;
  function sincronizarCajon() {
    if (cajonSincronizado) return;
    cajonSincronizado = true;
    var comp = document.querySelector("cart-drawer-component");
    if (!comp) return;
    function aplicar() {
      if (esMovil()) {
        if (comp.hasAttribute("auto-open")) {
          comp.mlAutoOpen = true;
          comp.removeAttribute("auto-open");
        }
      } else if (comp.mlAutoOpen) {
        comp.setAttribute("auto-open", "");
      }
    }
    aplicar();
    if (window.matchMedia) {
      var mq = window.matchMedia(MOVIL);
      if (mq.addEventListener) mq.addEventListener("change", aplicar);
      else if (mq.addListener) mq.addListener(aplicar);
    }
  }

  function iniciarBuybar(bar) {
    if (bar.mlIniciado) return;
    bar.mlIniciado = true;
    var panel = document.querySelector("[data-ml-buy]");
    var cierre = document.getElementById("ml-comprar");
    if (!panel || !("IntersectionObserver" in window)) return;
    /* El hidden lo pone Liquid: sin JS la barra no aparece. Al quitarlo
       entra inert: transform y opacity no impiden el foco. */
    bar.removeAttribute("hidden");
    bar.setAttribute("inert", "");
    var atar = correa();

    /* EL ANCLA DE LA BARRA ES EL BOTÓN, NO EL PANEL. Cambiado el 21/08/2026.

       Medído en la ficha de formación a 1280×720, con 1704 px de recorrido:
       la barra se encendía a los 851 y se apagaba a los 1259. Salía 408 px,
       el 24% del scroll, y el cliente veía un destello. Dos causas, las dos
       arregladas aquí.

       UNA: esperaba a que saliera de pantalla el PANEL ENTERO —título,
       subtítulo, chapa, precio, botón, nota y razones— y el panel es alto. Lo
       que la barra suple no es el panel: es el botón. Así que se mira el
       botón, y con eso enciende a los 671 en vez de a los 851.

       Y la regla queda dicha en una frase: la barra está encendida cuando no
       hay ningún botón de comprar en pantalla, y apagada cuando lo hay. */
    var boton = panel.querySelector("[data-ml-add]") || panel;

    /* DOS: EL PIE YA NO APAGA LA BARRA.
       Estaba en la lista de zonas junto al bloque de cierre, y no es la misma
       cosa. El bloque de cierre apaga porque LLEVA OTRO BOTÓN DE COMPRAR
       dentro, y enseñar el mismo botón dos veces sobra. El pie no lleva
       ninguno: lo único que conseguía era quitar la única forma de comprar
       justo cuando alguien acaba de leerse la ficha entera. En esta ficha el
       pie mide 445 px, o sea que se comía los últimos 445 px de página.

       La barra es una pastilla flotante y solapar el pie no rompe nada: se
       aparta con el pulgar o se llega al pie después de haber decidido. */
    var zonas = [cierre].filter(Boolean);
    function visible(el) {
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.bottom > 0 && r.top < (window.innerHeight || 0);
    }
    /* ¿El foco está dentro? Igual que en ml-capitulos.js, y el porqué, allí. */
    function conFoco() {
      var a = document.activeElement;
      return !!(a && a !== document.body && bar.contains(a));
    }

    /* EL TECHO: cuánto de la ventana tapa lo pegado arriba. Misma función que
       assets/ml-capitulos.js; el porqué, allí y en assets/ml-base.css. N54. */
    function techo() {
      var v = parseFloat(getComputedStyle(bar).getPropertyValue("--ml-techo"));
      return v > 0 ? v : 0;
    }

    /* Manda el borde inferior del botón, no el signo del superior: pasado por
       arriba, no por venir. Sin caja medible, nada. Y «arriba» ES EL TECHO Y NO
       EL CERO desde el 10/09/2026: encima hay una cabecera pegajosa de 60 px.
       Medido a 390×844: 96 px sin dónde comprar en formación y 97 en
       servicios. */
    function pintar() {
      /* Se lee en cada pintada —la cabecera cambia de alto— y si ha cambiado
         se vuelve a poner el cable en la línea nueva: ver armar(). */
      var t = Math.round(techo());
      if (t !== techoPuesto) armar(t);
      var r = boton.getBoundingClientRect();
      var on = r.height > 0 && r.bottom <= t && !zonas.some(visible);
      /* ── LA BARRA NO SE APAGA DEBAJO DEL FOCO (03/09/2026) ────────────
         Apagarla le pone «inert», y un «inert» encima del elemento enfocado se
         lleva el foco al <body>: el siguiente tabulador vuelve a empezar por la
         cabecera, sin aviso. Medido a 760×800: dos ArrowUp y el foco en BODY
         con la barra {on:false, inert:true}. Y desde que la confirmación mueve
         el foco a «Ver cesta» hay MÁS maneras de estar dentro.

         Esto solo puede RETRASAR el apagado, nunca encender una barra que no
         tocaba. El porqué largo, en assets/ml-capitulos.js. N34. */
      if (!on) {
        if (conFoco()) on = true;
      }
      bar.classList.toggle("is-on", on);
      if (on) bar.removeAttribute("inert");
      else bar.setAttribute("inert", "");
    }

    /* LAS DOS DIRECCIONES DEL FOCO, y hacen falta las dos.

       «focusin» en el documento y no «focusout» en la barra porque lo que
       interesa es adónde ha ido el foco, y ahí ya está en su destino. Pero
       cubre «el foco llega a algún sitio», que NO es «sale de la barra»:
       soltarlo al <body> —un párrafo, un blur()— no despacha «focusin», y el
       observador solo avisa AL CAMBIAR. Aquí decía que un cable cubría las dos
       direcciones y era falso: medido el 06/09/2026 a 390×844, la barra seguía
       encendida en y=0, con su tabulación viva, hasta y=360.

       El «focusout» pregunta en un setTimeout(0) porque durante el evento
       activeElement todavía dice quien PIERDE el foco, que es el motivo que
       daba el comentario viejo para no usarlo. Se limita a los que salen de
       la barra: ahí «e.target» sí es fiable. N34. */
    atar(document, "focusin", function () { pintar(); });

    var relojFoco = null;
    atar(document, "focusout", function (e) {
      if (!e || !e.target) return;
      if (!bar.contains(e.target)) return;
      window.clearTimeout(relojFoco);
      relojFoco = window.setTimeout(function () { pintar(); }, 0);
    });

    var cta = bar.querySelector("[data-ml-buybar-cta]");
    var ok = bar.querySelector("[data-ml-buybar-ok]");

    /* EL CLIC SE LE PASA AL BOTÓN DE VERDAD Y AQUÍ NO SE ENVÍA NADA.
       El porqué largo está en snippets/ml-buybar.liquid: montar aquí un
       segundo camino al carrito fue el fallo 4 del historial. Con esto la
       variante marcada, la cantidad, el estado de agotado, la burbuja y el
       cajón salen de <product-form-component>, que es quien ya lo hace bien.

       El disabled se comprueba igual aunque el botón de la barra también se
       pinte deshabilitado en pintarBoton: un botón deshabilitado no dispara
       click en ningún navegador serio, pero esta guarda cuesta una línea y
       cubre el hueco entre que carga el JS y se pinta la primera variante. */
    if (cta) {
      atar(cta, "click", function () {
        if (boton === panel || boton.disabled) return;
        boton.click();
      });
    }

    /* LA CONFIRMACIÓN DE MÓVIL. En escritorio se abre el cajón y esto no se
       usa: se comprueba esMovil() en el momento del evento y no al arrancar,
       porque entre el arranque y el clic cabe un giro de pantalla.

       Se cuelga del evento del carrito de Horizon y no del clic, para que
       diga «Añadido» cuando de verdad se ha añadido y no cuando se ha
       pulsado: si la llamada falla, la barra se queda como estaba y el error
       lo cuenta el panel, que es de donde salió el envío.

       Vuelve sola a los cuatro segundos para poder añadir otra vez.

       ══════════════════════════════════════════════════════════════
       QUÉ SE LE PREGUNTA AL EVENTO, Y POR QUÉ NO ES «e.detail.action»
       ══════════════════════════════════════════════════════════════
       Hasta el 03/09/2026 la guarda decía

           if (e && e.detail && e.detail.action && e.detail.action !== "add")

       y no filtraba NADA. El contrato que publica Shopify dentro del propio
       tema —assets/standard-events.d.ts, el tipo CartLinesUpdatePayload— pone
       «action» EN LA RAÍZ del payload, y la clase base ShopifyStandardEvent
       hace Object.assign(this, payload), así que «action» acaba en la raíz
       del evento. «detail» es otra cosa: un campo OPCIONAL para datos propios
       del tema, y en este evento normalmente no existe. Medido el 03/09/2026
       con la forma real del evento: e.detail es undefined y «detail» ni
       siquiera está en el objeto. Así que la condición cortocircuitaba en el
       segundo término y no descartaba ningún evento.

       Consecuencia, medida en 390×844 con el botón de quitar de Horizon: el
       cliente QUITA una línea del cajón y esta barra le dice «Añadido · Ver
       cesta» durante cuatro segundos. El emisor es
       assets/component-cart-items.js, que despacha action «update» o
       «remove» por el mismo evento. Es la misma línea, y el mismo arreglo,
       que en assets/ml-capitulos.js: las dos barras la copiaron una de otra.

       Y ahora se pide «add» EN POSITIVO, no «distinto de add». Sin action no
       hay prueba de que se haya añadido nada, y el contrato la da siempre en
       este evento: si algún día dejara de darla, esta caja no se encendería
       nunca y N14 se pondría roja. Un rojo se ve; una barra que miente, no.

       ══════════════════════════════════════════════════════════════
       Y EL FOCO, QUE SE CAÍA AL <body>
       ══════════════════════════════════════════════════════════════
       Esconder el botón esconde el elemento que tiene el foco, y el foco se
       va al <body>: quien compra con el teclado pierde el sitio y el
       siguiente tabulador vuelve a empezar por la cabecera. Medido el
       03/09/2026 en 760×800 sin táctil: después de comprar, BODY.

       Se mueve al enlace «Ver la cesta», que es el único control que aparece
       en el sitio del que desaparece y es lo siguiente que hará quien acaba
       de añadir. Y se mueve SOLO SI EL BOTÓN TENÍA EL FOCO: no se le quita el
       foco a nadie que estuviera en otra parte de la página.

       El orden importa y por eso no es el natural: se destapa la caja ANTES
       de tapar el botón, para que el foco salte de uno a otro sin pasar por
       el <body> ni un fotograma. A los cuatro segundos, el camino de vuelta,
       con el mismo cuidado. */
    if (ok && cta) {
      var reloj = null;
      var verCesta = ok.querySelector("a[href]");
      atar(document, "shopify:cart:lines-update", function (e) {
        if (!esMovil()) return;
        if (!e) return;
        if (e.action !== "add") return;
        var teniaFoco = cta.contains(document.activeElement);
        ok.hidden = false;
        if (teniaFoco) {
          if (verCesta) verCesta.focus();
        }
        cta.hidden = true;
        if (reloj) clearTimeout(reloj);
        reloj = setTimeout(function () {
          var vuelve = ok.contains(document.activeElement);
          cta.hidden = false;
          if (vuelve) cta.focus();
          ok.hidden = true;
        }, 4000);
      });
    }

    /* EL OBSERVADOR DESPIERTA EN LA LÍNEA EN LA QUE DECIDE pintar(), y hacen
       falta las dos direcciones: con la raíz recortada por el techo avisa justo
       cuando el borde de abajo del botón la cruza. Sin el recorte, SUBIENDO la
       barra se quedaba encendida con el botón del panel a la vista —medido, y
       contado con sus números en assets/ml-capitulos.js—. Se rearma cuando el
       techo cambia: una banda vieja con una condición fresca son dos líneas. */
    var obs = null;
    var techoPuesto = null;
    function armar(t) {
      techoPuesto = t;
      if (obs) obs.disconnect();
      obs = new IntersectionObserver(pintar, { threshold: [0, 1], rootMargin: -t + "px 0px 0px 0px" });
      obs.observe(boton);
      zonas.forEach(function (el) { obs.observe(el); });
    }
    armar(Math.round(techo()));
    pintar();
    /* Los DOS relojes se paran lo primero: cualquiera en vuelo repintaría
       encima del marcado recién devuelto.

       EL DE LA CONFIRMACIÓN NO SE PARABA (corregido el 06/09/2026), y al
       disparar hace tres cosas: destapa el botón, tapa la confirmación y, si
       el foco estaba dentro, lo mueve al botón. O sea que tras un
       «shopify:section:unload» —el editor de temas, en cada ajuste— este
       módulo tenía cuatro segundos para escribir sobre marcado que ya no
       manda. Lo vigila N44 y no N25: N25 mide la barra de capítulos, que sí
       restituye marcado al destruirse; esta no restituye nada, así que la
       única forma de ver el reloj es esperar los cuatro segundos. */
    bar.mlDestruir = function () {
      window.clearTimeout(relojFoco);
      window.clearTimeout(reloj);
      obs.disconnect();
      atar.soltar();
    };
  }

  /* ── ARRANQUE POR INSTANCIA · lo de dentro de root, y root ──── */
  function cada(root, sel, fn) {
    if (root.matches && root.matches(sel)) fn(root);
    lista(root.querySelectorAll(sel)).forEach(fn);
  }
  function init(root) {
    var base = root || document;
    if (!base || !base.querySelectorAll) return;
    cada(base, "[data-ml-gal]", iniciarGaleria);
    cada(base, "[data-ml-buy]", iniciarCompra);
    cada(base, "[data-ml-buybar]", iniciarBuybar);
  }
  function destruir(root) {
    if (!root || !root.querySelectorAll) return;
    cada(root, "[data-ml-gal],[data-ml-buy],[data-ml-buybar]", function (el) {
      if (typeof el.mlDestruir === "function") el.mlDestruir();
      el.mlIniciado = false;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else { init(document); }

  /* En el editor la sección se sustituye sin recargar. */
  document.addEventListener("shopify:section:load", function (e) { init(e.target || document); });
  document.addEventListener("shopify:section:unload", function (e) { destruir(e.target); });

  window.MLProducto = { init: init, destroy: destruir };
})();
